import React, { useContext } from 'react'
import { DataListUsers } from '../../components/DataListUsers'
import { GLOBALS } from '../../utils/Globals'
import { UserService } from '../../services/User'
import { Context } from '../../Context'
import { Layout } from '../../components/Layout'
import { getRole } from '../../utils/helpers/role.helper'

export const UserDataList = () => {
  const { isAuth: token } = useContext(Context)

  const roleBodyTemplate = (rowData) => {
    const role = getRole(rowData.role)
    return <span>{role ? role.name : ''}</span>
  }

  const columns = [
 
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por Nombre',
    },
    {
      field: 'email',
      header: 'Email',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por Email',
    },
    {
      field: 'role',
      header: 'Rol',
      sortable: true,
      filter: true,
      body: roleBodyTemplate,
      filterPlaceholder: 'Buscar por Rol',
    }
  ]
  return (
    <Layout>
      <DataListUsers
        menuItem={GLOBALS.menu.users}
        listItems={() => UserService.getAll(token)}
        bulkDelete={(ids) => UserService.bulkDelete(ids, token)}
        columns={columns}
      ></DataListUsers>
    </Layout>
  )
}
